module.exports = __webpack_public_path__ + "static/media/christmas-island.54fe34d6.svg";